﻿import {
	DriverId,
	DriverResult,
	PermitFullEntityResult, DriverPropertyFlags
} from "@2d-front-monorepo/permits-business";
import {JSX} from "react";
import {DriverComponent} from "./DriverComponent";

export function DriverWithChangeComponent({driver, hiddenEntityProperties, changedDriver}: {
	driver: PermitFullEntityResult<DriverId, DriverResult>,
	hiddenEntityProperties: DriverPropertyFlags,
	changedDriver: PermitFullEntityResult<DriverId, DriverResult> | undefined,
}): JSX.Element | undefined {
	if (!changedDriver) {
		return <DriverComponent driver={driver} hiddenEntityProperties={hiddenEntityProperties} showStatus={false}/>;
	}

	return <div className="grid">
		<div className="col-1of2"><DriverComponent driver={driver} hiddenEntityProperties={hiddenEntityProperties} showStatus={true}/></div>
		<div className="col-1of2"><DriverComponent driver={changedDriver} hiddenEntityProperties={hiddenEntityProperties} showStatus={true}/></div>
	</div>;
}
